module.exports = __webpack_public_path__ + "static/media/ChillWARE3_FAKE.ea855d56.png";